// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-partnership-track-truelink-index-js": () => import("./../src/pages/partnership-track/truelink/index.js" /* webpackChunkName: "component---src-pages-partnership-track-truelink-index-js" */)
}

